/// <reference path="../../../../../typings/jquery.d.ts"/>

import { User } from '../../../../../../shared/models/api/User/User';
import { ViewConfiguration } from '../../../../../../shared/services/BasicViewService';
import { BasicErrorService } from "../../../../../../shared/services/BasicErrorService";
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { AppApiService } from '../../services/AppApiService';
import { AppModelAdapter } from '../../models/AppModelAdapter';
import { AppUtils } from '../../../../../../shared/utils/index';

export class ConfirmationPageController implements StepController {
	private readonly $ctx: JQuery;
	private readonly options: BasicAppOptions<LocalAppDefinition>;
	private readonly appViewService: AppViewService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appApiService: AppApiService;
	private readonly parent: AppController;
	private readonly loader: BasicLoader<LocalAppDefinition>;
	private readonly appErrorService: BasicErrorService<LocalAppDefinition>;
	private readonly user: User;


	constructor(parent: AppController, options: BasicAppOptions<LocalAppDefinition>, loader: BasicLoader<LocalAppDefinition>, user: User) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.$ctx = $(options.$ctx);
		this.user = user;
		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);
		this.appApiService = new AppApiService(options);
		this.appErrorService = new BasicErrorService(options);
	}

	public start(): void {
		this.getSubmissionDate(() => {
			const viewConfig: ViewConfiguration<LocalAppDefinition> = {
				data: this.getViewOptions(),
				templateurl: this.options.app.currenttemplate.templateurl,
				campaignurls: this.options.app.campaignurls,
				parent: this,
				$ctx: this.$ctx,
				options: this.options,
				callback: this.afterRenderApp
			};
			this.appViewService.render(viewConfig);
		});
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			T.Utils.Tracking.pushKameleoonData();
			this.parent.afterRenderApp();

			const formModel = this.appPersistenceService.getFormModelFromStore();
			if (formModel.Email) {
				this.replaceEmailPlaceholder(formModel.Email);
			}

			this.sendConfirmation();
			this.appPersistenceService.clearApplicationSession();
			AppUtils.View.scrollTop();
		});
	}

	private getSubmissionDate(continueCallback: () => void): void {
		const formModel = this.appPersistenceService.getFormModelFromStore();

		this.appApiService.getSubmissionDate(formModel, () => {
			this.appPersistenceService.setFormModelToStore(formModel);
			continueCallback();
		});
	}

	private getViewOptions(): { [key: string]: any } {
		return {
			User: this.user,
			Form: this.appPersistenceService.getFormModelFromStore(),
			Vorgangsnummer: this.appPersistenceService.getApplicationModel().Vorgangsnummer
		};
	}

	private replaceEmailPlaceholder(email: string): void {
		const $emailConfirmationText = this.$ctx.find('.js-email-confirmation-text');
		if ($emailConfirmationText.length) {
			$emailConfirmationText.html($emailConfirmationText.html().replace("{Email}", `${email}`));
		}
	}

	private sendConfirmation(): void {
		AppUtils.View.startLoader();
		const requestModel = AppModelAdapter.getDsgvoAuskunftRequestApi(this.appPersistenceService.getApplicationModel(), this.appViewService.returnMainContentForApi());
		this.appApiService.sendConfirmation(requestModel, this.handleSubmitSuccessCallback.bind(this), this.handleSubmitErrorCallback.bind(this));
	}

	private handleSubmitSuccessCallback(): void {
		AppUtils.View.stopLoader();
	}

	private handleSubmitErrorCallback(): void {
		this.appErrorService.showGeneralErrorLayer();
		AppUtils.View.stopLoader();
	}
}